import React from 'react';
import './OurProducts.scss';
import bgGravity4AI from '../Assets/Images/Gravity4AI.jpg';
import bgEnergyAi from '../Assets/Images/electricity-power-nature-clean-energy-concept-solar-panel-with-turbine-tower-hight-voltage 1.png';
import logoEnergyAi from '../Assets/Images/logo-energyai.png';
import bgNajboljacena from '../Assets/Images/NC.png';
import logoNajboljacena from '../Assets/Images/logo-najboljacena.png';
import bgProcoach from '../Assets/Images/PC11.jpg';
import logoProcoach from '../Assets/Images/logo-procoach.svg';
import bgDigitalOffice from '../Assets/Images/DO.png';
import logoDigitalOffice from '../Assets/Images/logo-digitaloffice.png';
import { useInView } from '../hooks/useInView';

type LogoType = 'img' | 'text';

interface Product {
  bg: string;
  logoType: LogoType;
  logo?: string;
  logoText?: [string, string];
  name: string;
  description: string;
  link: string | null;
}

const products: Product[] = [
  {
    bg: bgGravity4AI,
    logoType: 'text',
    logoText: ['Gravity', '4AI'],
    name: 'Gravity4AI',
    description: 'Data and AI platform as a service, turns your data into action.',
    link: '/gravity4ai',
  },
  {
    bg: bgEnergyAi,
    logoType: 'img',
    logo: logoEnergyAi,
    name: 'Energy AI',
    description: 'AI optimization for smarter energy production and trading.',
    link: '/energyai',
  },
  {
    bg: bgNajboljacena,
    logoType: 'img',
    logo: logoNajboljacena,
    name: 'najboljacena.rs',
    description: 'Data and AI-driven pricing and product positioning that boosts conversion.',
    link: 'https://najboljacena.rs',
  },
  {
    bg: bgProcoach,
    logoType: 'img',
    logo: logoProcoach,
    name: 'ProCoach',
    description: 'Data platform for identifying and developing athletes.',
    link: 'https://www.procoach11.com/',
  },
  {
    bg: bgDigitalOffice,
    logoType: 'img',
    logo: logoDigitalOffice,
    name: 'Digital Office',
    description: 'All-in-one Microsoft 365 workspace for seamless daily operations.',
    link: '/digitalnakancelarija',
  },
];

function OurProducts() {
  const { ref: titleRef, visible: titleVisible } = useInView();
  const { ref: gridRef, visible: gridVisible } = useInView();

  return (
    <section className='our-products'>
      <h2
        className={`our-products-title anim-fade-up${titleVisible ? ' is-visible' : ''}`}
        ref={titleRef as React.RefObject<HTMLHeadingElement>}
      >
        <span className='black'>Our</span>
        <span className='orange'> products</span>
      </h2>
      <p className='our-products-subtitle'>
        Turning complexity into clarity, consolidate scattered data and apply AI across industries
        spanning energy, retail, sport, and daily operations, giving each one the tools to act on
        what the data actually says.
      </p>

      <div
        className={`products-grid${gridVisible ? ' cards-visible' : ''}`}
        ref={gridRef as React.RefObject<HTMLDivElement>}
      >
        {products.map((product, index) => {
          const logoNode = product.logoType === 'text' ? (
            <span className='product-logo-text'>
              <span className='text-dark'>{product.logoText![0]}</span>
              <span className='text-orange'>{product.logoText![1]}</span>
            </span>
          ) : (
            <img className='product-logo' src={product.logo ?? ''} alt={product.name} />
          );

          const inner = (
            <>
              <div className='product-card-photo'>
                <img src={product.bg} alt={product.name} />
              </div>
              <div className='product-card-info'>
                <div className='product-card-logo-row'>
                  {logoNode}
                </div>
                <p className='product-card-desc'>{product.description}</p>
              </div>
            </>
          );

          return product.link ? (
            <a
              className='product-card product-card-link'
              key={index}
              href={product.link}
              rel="noreferrer"
              target="_blank"
              style={{ animationDelay: `${index * 0.12}s` }}
            >
              {inner}
            </a>
          ) : (
            <div
              className='product-card'
              key={index}
              style={{ animationDelay: `${index * 0.12}s` }}
            >
              {inner}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default OurProducts;
